import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const AuthFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full border-t border-gray-200 py-6 px-4">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm text-gray-500">
        <Link to="/mentions-legales" className="hover:text-primary hover:underline">
          {t('footer.legal_notice')}
        </Link>
        <Link to="/cgvu" className="hover:text-primary hover:underline">
          {t('footer.terms')}
        </Link>
      </div>
    </footer>
  );
};
